import LoadingTableNormal from "components/shared-components/LoadingTableNormal";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, CardTitle } from "reactstrap";
import { useRouteLocalities } from "../../hooks/route-localities/useRouteLocalities";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
const RouteLocalitiesTable = props => {
  const { t } = useTranslation(["route"]);
  const {
    routeId,
    addressLevel = "all",
    onAddressLevelChange,
    addressLevelFilter,
    addressLevelFilterOptions,
    isOpenAddrFilter,
    setIsOpenAddrFilter,
  } = props;

  const [params, setParams] = useState({
    "filter[route_id]": props.routeId,
    // "filter[is_new_address]": props.isLevel2 ? "N" : "O",
    page: 1,
    "per-page": 10,
  });
  const { data: dataList, refetch: routeLocalities } =
    useRouteLocalities(params);
  let [isLoading, setIsLoading] = useState(props.isLoading);

  useEffect(() => {
    setIsLoading(props.isLoading);
  }, [props.isLoading]);

  // useEffect(() => {
  //   setParams(prev => ({
  //     ...prev,
  //     "filter[is_new_address]": props.isLevel2 ? "N" : "O",
  //     page: 1,
  //   }));
  // }, [props.isLevel2]);
  useEffect(() => {
    const newParams = {
      "filter[route_id]": routeId,
      page: 1,
      "per-page": 10,
    };

    if (addressLevel === "2") {
      newParams["filter[is_new_address]"] = "N";
    } else if (addressLevel === "3") {
      newParams["filter[is_new_address]"] = "O";
    }

    setParams(newParams);
  }, [routeId, addressLevel]);

  useEffect(() => {
    routeLocalities();
  }, [params]);

  const initColumns = useMemo(
    () => [
      {
        dataField: "address_type",
        text: "Loại địa chỉ",
        sort: false,
        hidden: addressLevel !== "all",
        formatter: (_cell, row) => {
          const isRowLevel2 =
            row?.is_new_address === "N" ||
            (!row?.ward_name && row?.district_name);
          return (
            <span
              className={`badge ${isRowLevel2 ? "bg-info" : "bg-secondary"}`}
              style={{
                fontSize: "11px",
                padding: "4px 8px",
                textAlign: "left",
                display: "inline-block",
              }}
            >
              {isRowLevel2 ? "2 cấp" : "3 cấp"}
            </span>
          );
        },
        headerStyle: () => {
          const width = window.innerWidth;
          if (width < 992) {
            return { minWidth: "40px", textAlign: "left" };
          } else {
            return { maxWidth: "30px", textAlign: "left" };
          }
        },
      },

      {
        dataField: "province_name",
        text: t("table.route_localities.province"),
        sort: false,
      },
      {
        dataField: "district_name",
        text: t("table.route_localities.district"),
        sort: false,
        formatter: (cell, row) => {
          if (row.is_new_address === "N") return "";
          return cell || t("table.route_localities.all");
        },
      },
      {
        dataField: "ward_name",
        text: t("table.route_localities.ward"),
        sort: false,
        formatter: (cell, row) => {
          const display =
            row.is_new_address === "N" ? row?.district_name : row?.ward_name;
          return display || t("table.route_localities.all");
        },
      },
    ],
    [t, addressLevel]
  );

  const columns = useMemo(() => {
    const baseColumns =
      addressLevel === "all" ? initColumns : initColumns.slice(1);

    if (addressLevel === "2") {
      return [baseColumns[0], baseColumns[2]];
    } else if (addressLevel === "3") {
      return baseColumns;
    } else {
      return baseColumns;
    }
  }, [addressLevel, initColumns]);
  const columnsWithFormatter = useMemo(() => {
    return columns.map(col => {
      if (col.dataField === "ward_name" && addressLevel === "2") {
        return {
          ...col,
          formatter: (cell, row) => {
            return row?.district_name || t("table.route_localities.all");
          },
        };
      }
      return col;
    });
  }, [columns, addressLevel, t]);
  const onTableChange = (_type, value) => {
    setParams(prev => ({
      ...prev,
      page: value.page,
      "per-page": value.sizePerPage,
    }));
  };

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <CardTitle className="mb-0">
            {t("table.route_localities.title")}
          </CardTitle>
          <div style={{ minWidth: 100 }}>
            <Dropdown
              isOpen={isOpenAddrFilter}
              toggle={() => setIsOpenAddrFilter(!isOpenAddrFilter)}
            >
              <DropdownToggle className=" w-100 text-overflow" caret>
                Địa chỉ
                <span>:&nbsp;{addressLevelFilter.label}</span>
                <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu className="w-100" style={{ minWidth: 100 }}>
                {addressLevelFilterOptions.map(opt => (
                  <DropdownItem
                    key={opt.value}
                    onClick={() => onAddressLevelChange(opt)}
                  >
                    {opt.label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        {isLoading ? (
          <LoadingTableNormal countColumn={`${columns.length}`} countRow="3" />
        ) : (
          <RemoteDataTable
            keyField="id"
            data={dataList?.items || []}
            columns={columns}
            isShowSearchAll={false}
            page={dataList?.params?.currentPage}
            sizePerPage={dataList?.params?.perPage}
            totalSize={dataList?.params?.totalCount || 0}
            loading={isLoading}
            isShowPagination={true}
            onTableChange={onTableChange}
          ></RemoteDataTable>
        )}
      </CardBody>
    </Card>
  );
};

RouteLocalitiesTable.propTypes = {
  routeId: PropTypes.number,
  isLoading: PropTypes.bool,
  addressLevel: PropTypes.oneOf(["all", "2", "3"]),
  onAddressLevelChange: PropTypes.func,
  addressLevelFilter: PropTypes.object,
  addressLevelFilterOptions: PropTypes.array,
  isOpenAddrFilter: PropTypes.bool,
  setIsOpenAddrFilter: PropTypes.func,
};

export default RouteLocalitiesTable;
